unit TermType;
{

/* Initial. */

}
interface

uses
  JS;

type
  TTermType = class
  private
    fCode: String;
    fEnglishTerm: String;
    fLanguageTerm: String;
    fMemberOf: String;
  public
    property Code: String read fCode;
    property EnglishTerm: String read fEnglishTerm;
    property LanguageTerm: String read fLanguageTerm;
    property MemberOf: String read fMemberOf;
    constructor Create(const String_JSON: String);
  end;

implementation

constructor TTermType.Create(const String_JSON: String);
var JSObject_Type: TJSObject;
begin
  if String_JSON <> 'null' then
  begin
    JSObject_Type := TJSJSON.parseObject(String_JSON);

    fCode := String(JSObject_Type['code']);
    fEnglishTerm := String(JSObject_Type['englishTerm']);
    fLanguageTerm := String(JSObject_Type['languageTerm']);
    fMemberOf := String(JSObject_Type['memberOf']);
  end;
end;

end.
